import { getApiBaseUrl } from '@/app/runtime';
import i18n from '@/i18n';
import axios from 'axios';
import normalizeBaseDomain from './normalizeBaseDomain';

const authMethod = process.env.VUE_APP_AUTH_METHOD || 'direct';
const baseDomain =
  authMethod === 'direct'
    ? normalizeBaseDomain(process.env.VUE_APP_SCRUMBLE_API_URL)
    : normalizeBaseDomain(getApiBaseUrl());
const baseURL =
  authMethod === 'direct'
    ? `${baseDomain}/` // OAuth endpoints at root for Scrumble
    : baseDomain.endsWith('/api/v2')
    ? `${baseDomain}/auth`
    : `${baseDomain}/api/v2/auth`;

const request = axios.create({
  baseURL,
});

const localDevelopment2faBypassToken = process.env.VUE_APP_LOCAL_DEVELOPMENT_2FA_BYPASS_TOKEN || '';

request.interceptors.request.use(
  (config) => {
    config.headers.set('Accept-Language', i18n.global.locale.value);

    if (localDevelopment2faBypassToken) {
      config.headers.set('X-Local-Development-2FA-Bypass-Token', localDevelopment2faBypassToken);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default request;
